import { render, staticRenderFns } from "./RecommendBlock.vue?vue&type=template&id=82e979e2&scoped=true"
import script from "./RecommendBlock.vue?vue&type=script&lang=js"
export * from "./RecommendBlock.vue?vue&type=script&lang=js"
import style0 from "./RecommendBlock.vue?vue&type=style&index=0&id=82e979e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e979e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82e979e2')) {
      api.createRecord('82e979e2', component.options)
    } else {
      api.reload('82e979e2', component.options)
    }
    module.hot.accept("./RecommendBlock.vue?vue&type=template&id=82e979e2&scoped=true", function () {
      api.rerender('82e979e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Incubator/RecommendBlock.vue"
export default component.exports